import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    MenuItem,
    Select,
    Typography,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    IconButton,
    TablePagination,
    Chip,
    TextField,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DownloadIcon from '@mui/icons-material/Download';
// import TableChartIcon from '@mui/icons-material/TableChart';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const summaryCards = [
    { label: 'Active Travel Card Balance', value: 'LKR 10,500.00', color: '#2e7d32', icon: '💳' },
    { label: 'Current Month Top-ups', value: 'LKR 2,120,000.00', color: '#1976d2', icon: '⬆️' },
    { label: 'Current Month Usage', value: 'LKR 1,950,000.00', color: '#ed6c02', icon: '💰' },
    { label: 'Current Month Depot Allocation Due', value: 'LKR 1,250,000.00', color: '#1976d2', icon: '🏢' },
    { label: 'Expired / Blocked Card Balance', value: 'LKR 275,000.00', color: '#d32f2f', icon: '⚠️' },
];

const accountSummaryRows = [
    { id: 1, cardNo: '1234-5678', passengerId: '1125-15331', passenger: 'John Silva', lastTopupDate: '10/04/2024', totalTopupValue: 'LKR 123,269.00', totalUsedValue: 'LKR 19,900.00', currentBalance: 'LKR 9,950,000', lastUsedBusNo: 'MB-995', lastUsedDepot: 'MB-699', status: 'Active' },
    { id: 2, cardNo: '1234-5679', passengerId: '1129-85309', passenger: 'Pavul Dejan', lastTopupDate: '10/04/2024', totalTopupValue: 'LKR 122,900.00', totalUsedValue: 'LKR 19,900.00', currentBalance: 'LKR 1,950,000', lastUsedBusNo: 'MB-999', lastUsedDepot: 'MB-699', status: 'Active' },
    { id: 3, cardNo: '1234-5679', passengerId: '1129-25533', passenger: 'Andrew Guoe', lastTopupDate: '10/04/2024', totalTopupValue: 'LKR 137,950.00', totalUsedValue: 'LKR 19,900.00', currentBalance: 'LKR 1,550,000', lastUsedBusNo: 'MB-889', lastUsedDepot: 'NWP', status: 'Active' },
    { id: 4, cardNo: '1234-5679', passengerId: '1125-65532', passenger: 'Jerry Tang', lastTopupDate: '10/04/2024', totalTopupValue: 'LKR 151,950.00', totalUsedValue: 'LKR 23,500.00', currentBalance: 'LKR 2,034,000', lastUsedBusNo: 'MB-668', lastUsedDepot: 'KUR', status: 'Active' },
    { id: 5, cardNo: '1234-5679', passengerId: '1129-38553', passenger: 'Jennifer Dals', lastTopupDate: '10/04/2024', totalTopupValue: 'LKR 500,670.00', totalUsedValue: 'LKR 22,500.00', currentBalance: 'LKR 2,063,000', lastUsedBusNo: 'MB-6333', lastUsedDepot: 'NWP', status: 'Active' },
    { id: 6, cardNo: '1234-5676', passengerId: '1129-38593', passenger: 'Terresa Hewitt', lastTopupDate: '10/04/2024', totalTopupValue: 'LKR 356,960.00', totalUsedValue: 'LKR 33,500.00', currentBalance: 'LKR 1,095,000', lastUsedBusNo: 'MK-2276', lastUsedDepot: 'KUR', status: 'Expired' },
];

const depotUsageRows = [
    { id: 1, depotCode: 'GAL', depotName: 'Galle Depot', usage: 'LKR 30,000.00', count: '10.000', reversals: '', notDue: 'LKR 6,000', status: 'Transfer' },
    { id: 2, depotCode: 'KND', depotName: 'Kandy Depot', usage: 'LKR 23,000.00', count: '', reversals: '', notDue: 'LKR 11,000', status: 'Hold' },
    { id: 3, depotCode: 'MRT', depotName: 'Maradana Depot', usage: 'LKR 23,000.00', count: '10.000', reversals: '', notDue: 'LKR 7,300', status: 'Transfer' },
    { id: 4, depotCode: 'NWP', depotName: 'Nawinna Depot', usage: 'LKR 35,000.00', count: '10.000', reversals: '', notDue: 'LKR 6,500', status: 'Hold' },
    { id: 5, depotCode: 'KUR', depotName: 'Kallyapitya Depot', usage: 'LKR 25,000.00', count: '10.000', reversals: '', notDue: 'LKR 9,200', status: 'Transfer' },
];

const passengerLedgerRows = [
    { id: 1, tanDateTime: '16/04/2024 14:45', tanType: 'Top-up', referenceNo: 'TXN-14.352', busNo: '', depotCode: '', debit: '2,000', runningBalance: 'LKR 3000', status: 'Confirmed', bankCard: 'Card', cardColor: '#ed6c02', },
    { id: 2, tanDateTime: '16/04/2024 15:22', tanType: 'Fare Debit', referenceNo: 'TXN-14.552', busNo: 'RNJ-2345', depotCode: 'KND', debit: '800', runningBalance: 'LKR 2200', status: 'Reversed', bankCard: 'Cash', cardColor: '#5c35a0', },
    { id: 3, tanDateTime: '16/04/2024 15:26', tanType: 'Fare Debit', referenceNo: 'TXN-14.532', busNo: 'RNJ-2367', depotCode: 'GAL', debit: '700', runningBalance: 'LKR 1500', status: 'Confirmed', bankCard: 'Cash', cardColor: '#1976d2', },
    { id: 4, tanDateTime: '16/04/2024 15:32', tanType: 'Fare Debit', referenceNo: 'TXN-14.332', busNo: 'GAL', depotCode: 'KND', debit: '500', runningBalance: 'LKR 1000', status: 'Pending', bankCard: 'Card', cardColor: '#2e7d32', },
    { id: 5, tanDateTime: '16/04/2024 16:32', tanType: 'Fare Debit', referenceNo: 'TXN-16.352', busNo: 'RNJ-2775', depotCode: 'NWP', debit: '100', runningBalance: 'LKR 900', status: 'Confirmed', bankCard: 'Card', cardColor: '#ed6c02', },
];

// ─── Status chips ─────────────────────────────────────────────────────────────

const CardStatusChip = ({ status }) => {
    const map = { Active: '#2e7d32', Expired: '#d32f2f', Blocked: '#5c35a0' };
    return <Chip label={status} size="small" sx={{ backgroundColor: map[status] || '#999', color: '#fff', fontWeight: 600, fontSize: 11, minWidth: 65 }} />;
};

const DepotStatusChip = ({ status }) => {
    const map = { Hold: '#ed6c02', Transfer: '#1976d2' };
    return <Chip label={status} size="small" sx={{ backgroundColor: map[status] || '#999', color: '#fff', fontWeight: 600, fontSize: 11, minWidth: 70 }} />;
};

const LedgerStatusChip = ({ status }) => {
    const map = { Confirmed: '#2e7d32', Reversed: '#d32f2f', Pending: '#ed6c02' };
    return <Chip label={status} size="small" sx={{ backgroundColor: map[status] || '#999', color: '#fff', fontWeight: 600, fontSize: 11, minWidth: 75 }} />;
};

// ─── Pagination hook ──────────────────────────────────────────────────────────

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────

const TravelCardLedgerSummaryPage = () => {

    // Filters
    const [dateRange, setDateRange] = useState('');
    const [cardStatus, setCardStatus] = useState('');
    const [depot, setDepot] = useState('');
    const [passengerSearch, setPassengerSearch] = useState('');

    // Detail modal
    const [detailOpen, setDetailOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const handleDetailOpen = (row) => { setCurrentRow(row); setDetailOpen(true); };
    const handleDetailClose = () => { setCurrentRow(null); setDetailOpen(false); };

    // Paginations
    const accountPag = usePagination();
    const depotPag = usePagination();
    const ledgerPag = usePagination();

    // Shared cell styles
    const thSx = { py: 1 };
    const tdSx = { py: 0 };

    return (
        <Container component="main" maxWidth="full" sx={{ py: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Title ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Travel Card Ledger Summary
                    </Typography>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                {/* ── Summary Cards ── */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: 2,
                        width: '100%',
                        mb: 3
                    }}
                >
                    {summaryCards.map((card) => (
                        <Paper
                            key={card.label}
                            variant="outlined"
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5
                            }}
                        >
                            <Typography sx={{ fontSize: 24 }}>{card.icon}</Typography>
                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 11 }}>
                                    {card.label}
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: 700, color: card.color, lineHeight: 1.3 }}
                                >
                                    {card.value}
                                </Typography>
                            </Box>
                        </Paper>
                    ))}
                </Box>

                {/* ── Filter Bar ── */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: 1.5,
                        width: '100%',
                        mb: 1,
                        alignItems: 'center'
                    }}
                >
                    <FormControl size="small" fullWidth>
                        <InputLabel>Date Range</InputLabel>
                        <Select value={dateRange} onChange={e => setDateRange(e.target.value)} label="Date Range">
                            <MenuItem value="today">Today</MenuItem>
                            <MenuItem value="this_week">This Week</MenuItem>
                            <MenuItem value="this_month">This Month</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl size="small" fullWidth>
                        <InputLabel>Card Status</InputLabel>
                        <Select value={cardStatus} onChange={e => setCardStatus(e.target.value)} label="Card Status">
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="expired">Expired</MenuItem>
                            <MenuItem value="blocked">Blocked</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl size="small" fullWidth>
                        <InputLabel>Depot</InputLabel>
                        <Select value={depot} onChange={e => setDepot(e.target.value)} label="Depot">
                            <MenuItem value="GAL">Galle (GAL)</MenuItem>
                            <MenuItem value="KND">Kandy (KND)</MenuItem>
                            <MenuItem value="MRT">Maradana (MRT)</MenuItem>
                            <MenuItem value="NWP">Nawinna (NWP)</MenuItem>
                            <MenuItem value="KUR">Kallyapitya (KUR)</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        fullWidth
                        size="small"
                        label="Passenger Name / Card No."
                        value={passengerSearch}
                        onChange={e => setPassengerSearch(e.target.value)}
                    />
                </Box>

                {/* ── Action buttons ── */}
                <Box sx={{ display: 'flex', gap: 1.5, mb: 3, alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                    <Button variant="contained"
                        sx={{ padding: '6px 24px', fontWeight: 'bold', borderRadius: '4px', height: '40px', backgroundColor: '#3f51b5', color: '#fff', '&:hover': { backgroundColor: '#303f9f' } }}>
                        Apply Filters
                    </Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} endIcon={<KeyboardArrowDownIcon />}
                        sx={{ fontWeight: 'bold', borderRadius: '4px', height: '40px', textTransform: 'none' }}>
                        Export
                    </Button>
                </Box>

                {/* ══════════════════════════════════════════
                    TABLE 1 — Travel Card Account Summary
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Travel Card Account Summary</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton size="small"><DownloadIcon /></IconButton>
                        <IconButton size="small"><MoreHorizIcon /></IconButton>
                    </Box>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>#</TableCell>
                                <TableCell sx={thSx}>Card No.</TableCell>
                                <TableCell sx={thSx}>Passenger ID</TableCell>
                                <TableCell sx={thSx}>Passenger</TableCell>
                                <TableCell sx={thSx}>Last Top-up Date</TableCell>
                                <TableCell sx={thSx}>Total Top-up Value</TableCell>
                                <TableCell sx={thSx}>Total Used Value</TableCell>
                                <TableCell sx={thSx}>Current Balance</TableCell>
                                <TableCell sx={thSx}>Last Used Bus No.</TableCell>
                                <TableCell sx={thSx}>Last Used Depot</TableCell>
                                <TableCell sx={thSx}>Card Status</TableCell>
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {accountSummaryRows
                                .slice(accountPag.startIndex, accountPag.startIndex + accountPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={tdSx}>{row.id}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Typography variant="body2"
                                                sx={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}
                                                onClick={() => handleDetailOpen(row)}>
                                                {row.cardNo}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.passengerId}</TableCell>
                                        <TableCell sx={tdSx}>{row.passenger}</TableCell>
                                        <TableCell sx={tdSx}>{row.lastTopupDate}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.totalTopupValue}</TableCell>
                                        <TableCell sx={tdSx}>{row.totalUsedValue}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.currentBalance}</TableCell>
                                        <TableCell sx={tdSx}>{row.lastUsedBusNo}</TableCell>
                                        <TableCell sx={tdSx}>{row.lastUsedDepot}</TableCell>
                                        <TableCell sx={tdSx}><CardStatusChip status={row.status} /></TableCell>
                                        <TableCell sx={tdSx}>
                                            <Button size="small" endIcon={<KeyboardArrowDownIcon />}
                                                sx={{ minWidth: 0, p: '2px 6px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none' }}>
                                                •••
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={accountSummaryRows.length}
                        page={accountPag.page}
                        onPageChange={accountPag.handleChangePage}
                        rowsPerPage={accountPag.rowsPerPage}
                        onRowsPerPageChange={accountPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    TABLE 2 — Travel Card Usage Payable by Depot
                ══════════════════════════════════════════ */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 4, flexWrap: 'wrap', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Travel Card Usage Payable by Depot</Typography>
                    </Box>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Depot Code</TableCell>
                                <TableCell sx={thSx}>Depot Name</TableCell>
                                <TableCell sx={thSx}>Usage</TableCell>
                                <TableCell sx={thSx}>Count</TableCell>
                                <TableCell sx={thSx}>Reversals</TableCell>
                                {/* <TableCell sx={thSx}>Not Due</TableCell> */}
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {depotUsageRows
                                .slice(depotPag.startIndex, depotPag.startIndex + depotPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700, color: '#1976d2' }}>{row.depotCode}</TableCell>
                                        <TableCell sx={tdSx}>{row.depotName}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.usage}</TableCell>
                                        <TableCell sx={tdSx}>{row.count || '—'}</TableCell>
                                        <TableCell sx={tdSx}>{row.reversals || '—'}</TableCell>
                                        {/* <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.notDue}</TableCell> */}
                                        <TableCell sx={tdSx}><DepotStatusChip status={row.status} /></TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={depotUsageRows.length}
                        page={depotPag.page}
                        onPageChange={depotPag.handleChangePage}
                        rowsPerPage={depotPag.rowsPerPage}
                        onRowsPerPageChange={depotPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    TABLE 3 — Passenger Travel Card Ledger
                ══════════════════════════════════════════ */}

                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 4, flexWrap: 'wrap', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Passenger Travel Card Ledger</Typography>
                    </Box>
                    <IconButton size="small"><MoreHorizIcon /></IconButton>
                </Box>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: 1.5,
                        width: '100%',
                        mb: 2,
                        alignItems: 'center'
                    }}
                >
                    <FormControl size="small" fullWidth>
                        <InputLabel>Date Range</InputLabel>
                        <Select value={dateRange} onChange={e => setDateRange(e.target.value)} label="Date Range">
                            <MenuItem value="today">Today</MenuItem>
                            <MenuItem value="this_week">This Week</MenuItem>
                            <MenuItem value="this_month">This Month</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        fullWidth
                        size="small"
                        label="Passenger Name / Card No."
                        value={passengerSearch}
                        onChange={e => setPassengerSearch(e.target.value)}
                    />
                </Box>
  <Box sx={{ width: '100%', mb: 2, gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                        <Typography variant="h7" sx={{ fontWeight: 600 }}>Passenger Name: </Typography>
                        <Typography variant="h7" sx={{ fontWeight: 400 }}>Sunil Perera </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                        <Typography variant="h7" sx={{ fontWeight: 600 }}>Travel Card No: </Typography>
                        <Typography variant="h7" sx={{ fontWeight: 400 }}>123456 </Typography>
                    </Box>
                </Box>
                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Txn Date Time</TableCell>
                                <TableCell sx={thSx}>Txn Type</TableCell>
                                <TableCell sx={thSx}>Reference No.</TableCell>
                                <TableCell sx={thSx}>Bus No.</TableCell>
                                <TableCell sx={thSx}>Depot Code</TableCell>
                                <TableCell sx={thSx}>Debit/Credit</TableCell>
                                <TableCell sx={thSx}>Running Balance</TableCell>
                                <TableCell sx={thSx}>Payment Method</TableCell>
                                <TableCell sx={thSx}>Pass No</TableCell>
                                <TableCell sx={thSx}>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {passengerLedgerRows
                                .slice(ledgerPag.startIndex, ledgerPag.startIndex + ledgerPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={tdSx}>{row.tanDateTime}</TableCell>
                                        <TableCell sx={tdSx}>{row.tanType}</TableCell>
                                        <TableCell sx={tdSx}>{row.referenceNo}</TableCell>
                                        <TableCell sx={tdSx}>{row.busNo}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 700, color: '#1976d2' }}>{row.depotCode}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.debit}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.runningBalance}</TableCell>
                                        <TableCell sx={tdSx}>
                                           {row.bankCard}
                                        </TableCell>
                                        <TableCell sx={tdSx}>123456</TableCell>
                                        <TableCell sx={tdSx}><LedgerStatusChip status={row.status} /></TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={passengerLedgerRows.length}
                        page={ledgerPag.page}
                        onPageChange={ledgerPag.handleChangePage}
                        rowsPerPage={ledgerPag.rowsPerPage}
                        onRowsPerPageChange={ledgerPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ══════════════════════════════════════════
                    Card Detail Modal — same style as sample
                ══════════════════════════════════════════ */}
                <Modal open={detailOpen} onClose={handleDetailClose}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        maxWidth: 540,
                        bgcolor: 'background.paper',
                        border: '2px solid gray',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '10px',
                    }}>
                        <Typography variant="h6" gutterBottom>Card Detail — {currentRow?.cardNo}</Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Passenger ID" value={currentRow?.passengerId || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Passenger Name" value={currentRow?.passenger || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Last Top-up Date" value={currentRow?.lastTopupDate || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Current Balance" value={currentRow?.currentBalance || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Total Top-up Value" value={currentRow?.totalTopupValue || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Total Used Value" value={currentRow?.totalUsedValue || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Last Used Bus No." value={currentRow?.lastUsedBusNo || ''} sx={{ mb: 1 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth disabled size="small" label="Last Used Depot" value={currentRow?.lastUsedDepot || ''} sx={{ mb: 1 }} />
                            </Grid>
                        </Grid>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button variant="contained" color="primary" onClick={handleDetailClose} sx={{ marginRight: '8px' }}>
                                Close
                            </Button>
                            <Button variant="contained" onClick={handleDetailClose} sx={{ backgroundColor: 'gray' }}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Modal>

            </Box>
        </Container>
    );
};

export default TravelCardLedgerSummaryPage;